import React,{useState} from 'react'


const FetchWeather = () => {
  const [data, setData] = useState({});
  const [name, setName] = useState("");
  const [showData, setShowData] = useState(false);
  const [message, setMessage] = useState(false);

  //let today = new Date();
  //let day = today.getDate();
  //let month = today.getMonth() + 1;
  //let year = today.getFullYear();
  //let date = day + "/" + month + "/"+ year;

  let urlimg="";
  let iconUrl="";

  //Obtener nombre  
  const handleSubmit = (event) => {
    event.preventDefault();
    getWeather(name);
  }
   
  const getWeather = async(name)  => {
    try {
      const url=`https://api.openweathermap.org/data/2.5/weather?q=${name}&units=metric&appid=ce74bfc8bcaf58d132225959cac9fe1a&lang=es`;
      const resp = await fetch (url);
      const data1 = await resp.json();
      
      if (resp.status===200) {
        console.log(data1);
        showWeather(data1);
        setData(data1);
      } else if(resp.status===401) {
        console.log('Pusiste la key mal');
      } else if(resp.status===404) {
        console.log('No existe el resultado');
        //console.log('Hubo un error y no se sabe que paso');
        setShowData(false);
        setMessage(true);
      }
    } catch (error) {
      console.log('Hubo un problema con la petición Fetch:' + error.message);
    }

    /*fetch("https://api.openweathermap.org/data/2.5/weather?q=London&appid=ce74bfc8bcaf58d132225959cac9fe1a")
    .then((response) => response.json())  
	  .then((data) => console.log(data));*/

    //https://www.youtube.com/watch?v=UjeXpct3p7M
    //https://www.escuelafrontend.com/data-fetching-con-react
  }

  const showWeather = async(datos)  => {
   // const {name, main:{temp, temp_min, temp_max}, weather:[arr]}= datos;
    setShowData(true);
  }

  if(showData){
    urlimg="http://openweathermap.org/img/w/";
    iconUrl = urlimg+ data.weather[0].icon+".png"
  }

  return (
    <>
      <div className='container-weather'>
        <div className='card-weather'>
          <h1 className='title-welcome'>¿Cómo está el clima hoy?</h1>

          <form onSubmit={handleSubmit} className="form-weather">
            <label>
              <input 
                type="text" 
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="input-text"
                placeholder='Tu ciudad: Temixco'
              />
            </label>
            <input type="submit" value="Buscar" className='btn-search'/>
          </form>

          <div className='card-info'>
            {
              showData === true ? (
                <>
                  <p className='icon-city'><img src={iconUrl} alt="icon-weather"/></p>
                  <p className='title-city'>{data.name} </p>
                  <p className='temp-city'>{Math.round(data.main.temp)} °C</p>
                  <p className='descrip-city'>{data.weather[0].description}</p>
                  <p className='max-city'>Max: {data.main.temp_max} °C</p>
                  <p className='min-city'>Min: {data.main.temp_min} °C</p>
                </>
              ):(
                <p></p>
              )
            }
            {
              message === true ? (
                <p>No hay resultados</p>
              ):(
                <p></p>
              )
            }

          </div>

        </div>

      </div>    
    </>
  )
}

export default FetchWeather